import { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import './App.css';
import MainNavBar from './components/MainNavBar';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './contexts/AuthProvider';
import { AccountDeletions } from './pages/AccountDeletions/AccountDeletions';
import { Api } from './pages/Api/Api';
import { AudioGuides } from './pages/AudioGuides/AudioGuides';
import CommunityQuestions from './pages/Community/CommunityQuestions';
import Dashboard from './pages/Dashboard/Dashboard';
import { FeedbackCampaigns } from './pages/FeedbackCampaigns/FeedbackCampaigns';
import { Hipaa } from './pages/Hipaa/Hipaa';
import ManageLessons from './pages/Lessons/ManageLessons';
import Login from './pages/Login';
import NotFound from './pages/NotFound';
import { OcdProfile } from './pages/OcdProfile/OcdProfile';
import { DailyTasks } from './pages/DailyTasks/DailyTasks';
import { EvalRun } from './pages/Evals/EvalRun';
import { Evals } from './pages/Evals/Evals';
import { Cases } from './pages/Evals/Cases';
import { EvalRuns } from './pages/Evals/EvalRuns';
import { JudgePrompts } from './pages/Evals/JudgePrompts';
import { Journey } from './pages/Journey/Journey';
import { Streaks } from './pages/Streaks/Streaks';
import { Quests } from './pages/Quests/Quests';
import { ReferralCodes } from './pages/ReferralCodes/ReferralCodes';
import { Settings } from './pages/Settings/Settings';
import { Stats } from './pages/Stats/Stats';
import { Tools } from './pages/Tools/Tools';
import Unauthorized from './pages/Unauthorized';
import UserFeedback from './pages/UserFeedback/UserFeedback';

function App() {
  return (
    <AuthProvider>
      <MainNavBar />
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/streaks" element={<ProtectedRoute><Streaks /></ProtectedRoute>} />
          <Route path="/" element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/lessons"
            element={
              <ProtectedRoute>
                <ManageLessons />
              </ProtectedRoute>
            }
          />
          <Route
            path="/feedback"
            element={
              <ProtectedRoute>
                <UserFeedback />
              </ProtectedRoute>
            }
          />
          <Route
            path="/feedback-campaigns"
            element={
              <ProtectedRoute>
                <FeedbackCampaigns />
              </ProtectedRoute>
            }
          />
          <Route
            path="/community-questions"
            element={
              <ProtectedRoute>
                <CommunityQuestions />
              </ProtectedRoute>
            }
          />
          <Route
            path="/quests"
            element={
              <ProtectedRoute>
                <Quests />
              </ProtectedRoute>
            }
          />
          <Route
            path="/journey"
            element={
              <ProtectedRoute>
                <Journey />
              </ProtectedRoute>
            }
          />
          <Route
            path="/daily-tasks"
            element={
              <ProtectedRoute>
                <DailyTasks />
              </ProtectedRoute>
            }
          />
          <Route
            path="/user-profile/:userId?"
            element={
              <ProtectedRoute>
                <OcdProfile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tools"
            element={
              <ProtectedRoute>
                <Tools />
              </ProtectedRoute>
            }
          />
          <Route
            path="/audio-guides"
            element={
              <ProtectedRoute>
                <AudioGuides />
              </ProtectedRoute>
            }
          />
          <Route
            path="/stats"
            element={
              <ProtectedRoute>
                <Stats />
              </ProtectedRoute>
            }
          />
          <Route
            path="/evals"
            element={
              <ProtectedRoute>
                <Evals />
              </ProtectedRoute>
            }
          />
          <Route
            path="/evals/runs"
            element={
              <ProtectedRoute>
                <EvalRuns />
              </ProtectedRoute>
            }
          />
          <Route
            path="/evals/cases"
            element={
              <ProtectedRoute>
                <Cases />
              </ProtectedRoute>
            }
          />
          <Route
            path="/evals/judge-prompts"
            element={
              <ProtectedRoute>
                <JudgePrompts />
              </ProtectedRoute>
            }
          />
          <Route
            path="/evals/:runId"
            element={
              <ProtectedRoute>
                <EvalRun />
              </ProtectedRoute>
            }
          />
          <Route
            path="/referral-codes"
            element={
              <ProtectedRoute>
                <ReferralCodes />
              </ProtectedRoute>
            }
          />
          <Route
            path="/hipaa"
            element={
              <ProtectedRoute>
                <Hipaa />
              </ProtectedRoute>
            }
          />
          <Route
            path="/account-deletions"
            element={
              <ProtectedRoute>
                <AccountDeletions />
              </ProtectedRoute>
            }
          />
          <Route
            path="/api"
            element={
              <ProtectedRoute>
                <Api />
              </ProtectedRoute>
            }
          />
          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </AuthProvider>
  );
}

export default App;
